var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.4 90",
    style: {
      enableBackground: "new 0 0 97.4 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5271.8,2395.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4 c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5271.1,2398.7,5271.8,2396.9,5271.8,2395.1z  M5262.1,2395c-4.8,0-7.4-1.3-7.5-1.8l0,0c0.1-0.5,2.7-1.8,7.5-1.8s7.3,1.3,7.5,1.8C5269.4,2393.7,5266.9,2395,5262.1,2395z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5267.1,2405.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1s-0.4-1-1-1H5267.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5271.4,2408.7h-4.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5272.4,2409.1,5272,2408.7,5271.4,2408.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5271.4,2412h-4.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5272.4,2412.5,5272,2412,5271.4,2412z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,78l-8.9-23.6c-0.6-1.5-2.2-2.3-3.7-1.9l-26.2,7.6l-12.7-2.7v8.9c0,4.6-3.7,8.3-8.3,8.3c-4.5,0-8.3-3.7-8.3-8.3V53.9 l-6.3-1.4c-1-0.2-2,0.1-2.7,0.7l-16.6,15c-1,0.9-1.3,2.6-0.6,3.8l9.5,16.5c0.5,0.9,1.6,1.5,2.7,1.5h56.9c0.3,0,0.7,0,1-0.1 L94.1,82c0.8-0.3,1.4-0.9,1.8-1.6C96.2,79.6,96.3,78.8,96,78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1,69.4c1.7,0,3.1-1.4,3.1-3.1V37.8h29.6c1.7,0,3.1-1.4,3.1-3.1V9.2c0-1.7-1.4-3.1-3.1-3.1H39.2v-3 c0-1.7-1.4-3.1-3.1-3.1C34.4,0,33,1.4,33,3.1v63.2C33.1,68,34.4,69.4,36.1,69.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgState);
export default __webpack_public_path__ + "static/media/state.fbe7994b6c3864f7a68e9ece172f9956.svg";
export { ForwardRef as ReactComponent };